import { EffectsCommandMap } from 'dva';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import { history } from '@@/core/history';
import { PolicyFullInfo_Type } from '@/type/contractTypes';
import { ConnectState } from '@/models/connect';
import fMessage from '@/components/fMessage';
import type {
  ChangeAction,
  Sider_OnMount_Page_Action,
  Sider_OnUnmount_Page_Action,
  Sider_OnChange_Page_Action,
  Sider_OnUpdate_Data_Action,
  Sider_FetchInfoAction,
} from './types';

export const siderEffects = {
  *sider_onMount_Page(
    { payload }: Sider_OnMount_Page_Action,
    { select, put }: EffectsCommandMap,
  ) {
    const { collectionManager }: ConnectState = yield select(
      ({ collectionManager }: ConnectState) => ({
        collectionManager,
      }),
    );
    if (payload.resourceID === collectionManager.sider_resourceID) {
      return;
    }
    if (collectionManager.sider_resourceID !== '') {
      return;
    }
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        sider_resourceID: payload.resourceID,
      },
    });
    yield put<Sider_FetchInfoAction>({
      type: 'sider_fetchInfo',
    });
  },
  *sider_onUnmount_Page({}: Sider_OnUnmount_Page_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        sider_state: 'loading',
        sider_resourceID: '',
        sider_resourceName: '',
        sider_resourceTitle: '',
        sider_resourceState: '',
        sider_resourceCover: '',
        sider_resourceType: [],
        sider_resourceVersions: [],
        sider_isChoice: false,
        sider_showPage: '',
        sider_hasAuthProblem: false,
        sider_policies: [],
      },
    });
  },
  *sider_onChange_Page({ payload }: Sider_OnChange_Page_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        sider_showPage: payload.page,
      },
    });
  },
  *sider_onUpdate_Data({}: Sider_OnUpdate_Data_Action, { put }: EffectsCommandMap) {
    yield put<Sider_FetchInfoAction>({
      type: 'sider_fetchInfo',
    });
  },
  *sider_fetchInfo({}: Sider_FetchInfoAction, { call, select, put }: EffectsCommandMap) {
    const { collectionManager }: ConnectState = yield select(
      ({ collectionManager }: ConnectState) => ({
        collectionManager,
      }),
    );
    const params: Parameters<typeof FServiceAPI.Resource.info>[0] = {
      resourceIdOrName: collectionManager.sider_resourceID,
      isLoadPolicyInfo: 1,
      isTranslate: 1,
    };
    const {
      ret,
      errCode,
      msg,
      data: data_resourceInfo,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        userId: number;
        status: number;
        resourceId: string;
        resourceName: string;
        resourceTitle: string;
        resourceVersions: {
          version: string;
        }[];
        latestVersion: string;
        coverImages: string[];
        resourceType: string[];
        policies: PolicyFullInfo_Type[];
        operationType: 0 | 1 | 2 | 3 | 4 | 5;
        subjectType: 1 | 4;
      };
    } = yield call(FServiceAPI.Resource.info, params);

    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }

    if (!data_resourceInfo || data_resourceInfo.userId !== FUtil.Tool.getUserIDByCookies()) {
      history.replace(FUtil.LinkTo.exception403());
      return;
    }

    if (data_resourceInfo.status === 2) {
      history.replace(
        FUtil.LinkTo.resourceFreeze({
          resourceID: data_resourceInfo.resourceId,
        }),
      );
      return;
    }

    if (data_resourceInfo.subjectType === 1) {
      self.location.replace(self.location.href.replace('/collectionSidebar/', '/sidebar/'));
      return;
    }

    let authProblem: boolean = false;
    if (data_resourceInfo.latestVersion !== '') {
      const params1: Parameters<typeof FServiceAPI.Resource.batchAuth>[0] = {
        resourceIds: data_resourceInfo.resourceId,
      };
      const {
        ret,
        errCode,
        data: data_batchAuth,
      } = yield call(FServiceAPI.Resource.batchAuth, params1);

      if (ret === 0 && errCode === 0) {
        authProblem = !data_batchAuth[0].isAuth;
      } else {
        authProblem = false;
      }
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        sider_state: 'loaded',
        sider_resourceName: data_resourceInfo.resourceName,
        sider_resourceTitle: data_resourceInfo.resourceTitle,
        sider_resourceState:
          data_resourceInfo.status === 0
            ? 'unreleased'
            : data_resourceInfo.status === 4
            ? 'offline'
            : 'online',
        sider_resourceCover: data_resourceInfo.coverImages[0] || '',
        sider_resourceType: data_resourceInfo.resourceType,
        sider_resourceVersions: data_resourceInfo.resourceVersions.map((v) => {
          return v.version;
        }),
        sider_hasAuthProblem: authProblem,
        sider_policies: data_resourceInfo.policies,
        sider_isChoice: data_resourceInfo.operationType === 5,
      },
    });
  },
};
